import axios from 'axios';

let promise = new Promise((resolve, rejects) => {
    if (window.$bus) {
        resolve(window.$bus)
    } else {
        setTimeout(() => {
            resolve(window.$bus)
        }, 20);
    }
})


let requestHandler = {
    url: "",
    data: {},
    params: {},
    isToast: true,
    success: function(res) {
        // success  
    },
    fail: function(error) {
        // fail  
    },
}

//GET请求  
function GET(requestHandler) {
    request('GET', requestHandler)
}
//POST请求  
function POST(requestHandler) {
    request('POST', requestHandler)
}
//DELETE请求  
function DELETE(requestHandler) {
    request('DELETE', requestHandler)
}
//PUT请求  
function PUT(requestHandler) {
    request('PUT', requestHandler)
}

function request(method, requestHandler) {
    var data = requestHandler.data;
    var params = requestHandler.params;
    var apiUrl = requestHandler.url;
    var isToast = requestHandler.isToast;
    //是否提示错误
    if (typeof requestHandler.isToast === 'undefined') {
        isToast = true
    }
    promise.then(res => {
        let appVue = res;
        //拦截器  请求前操作
        axios.interceptors.request.use(function(config) {
            let TOKEN = localStorage.getItem('accessToken');
            if (TOKEN && appVue.$route.path !== '/login') {
                config.headers.common['Authorization'] = TOKEN;
            }
            return config;
        })
        axios({
            url: apiUrl,
            headers: {
                'Content-Type': 'application/json',
            },
            method: method,
            params: params,
            data: JSON.stringify(data),
        }).then(function(respons) {
            //请求状态码在200之间
            if (respons.status >= 200 && respons.status < 300) {
                if(respons.data.result)
                {
                    requestHandler.success(respons.data.result);
                }
                else
                {
                    requestHandler.success(respons.data);
                }
                
               
            } else {
                requestHandler.fail(respons.data);
            }
        }).catch(error => {
            let errorInfo = error.response.data.error;
            if (errorInfo.code == 10001) {
                appVue.$message.error('登录失效，请重新登录')
                appVue.$router.push({
                    'path': '/login'
                })
                return;
            }
            //是否错误弹框提示
            if (isToast) {
                appVue.$message.error(errorInfo.message);
            }
            if (requestHandler.fail) {
                requestHandler.fail(errorInfo)
            }
        })

    })
}


export default {
    GET: GET,
    POST: POST,
    DELETE: DELETE,
    PUT: PUT
}